<template>
  <div>
    <ServicesCard
      cardHeadline="Tjenester"
      v-model="services"
      @click="click"
    ></ServicesCard>

    <RHorRODialog v-model="showRHorRODialog" :query="query" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ServicesCard from "@/components/shared/cards/ServicesCard.vue";
import RHorRODialog from "@/components/aberration/new/children/RHorRODialog.vue";

export default Vue.extend({
  name: "ProjectShortcuts",
  data() {
    return {
      showRHorRODialog: false,
      query: undefined,
    };
  },
  methods: {
    click(item: any) {
      this.query = undefined;
      this.showRHorRODialog = true;
      this.query = item.query;
    },
  },
  computed: {
    services(): Array<any> {
      const query = {
        projectId: this.$route.params.id,
        houseId: this.$route.params.houseId,
      };

      const services = [
        {
          icon: "mdi-progress-wrench",
          title: "Nytt avvik",
          to: "Aberration",
          query: query,
        },
        {
          icon: "mdi-alert-octagram-outline",
          title: "HMS-rapport",
          // to: "RUH",
          query: query,
          // emit: "openRHorRODialog",
        },
        {
          icon: "mdi-account-group-outline",
          title: "Kontakter",
          to: "ProjectContacts",
          // to: "Checklists",
          // count: 4,
        },
        {
          icon: "mdi-account-hard-hat",
          title: "HMS Plan",
          to: "ProjectHms",
        },
        {
          icon: "mdi-script-text-outline",
          title: "Møte.ref",
          to: "ProjectMinutes",
        },
        {
          icon: "mdi-file-document-multiple-outline",
          title: "Dokumenthotell",
          to: "ProjectDocuments",
        },
      ];

      return services;
    },
  },
  components: {
    ServicesCard,
    RHorRODialog,
  },
});
</script>
